import { GermanyAussere } from "./GermanyAussere";
import { GermanyPfahlkopf } from "./GermanyPfahlkopf";
import { GermanyInnere } from "./GermanyInnere";

export function Germany({ data, settings }) {
  let showInnere = settings.find((item) => {
    return item.name === "euroInnere";
  });

  let showAussere = settings.find((item) => {
    return item.name === "euroAussere";
  });
  let showPileHead = settings.find((item) => {
    return item.name === "euroAusserePfahlkopf";
  });
  return (
    <>
      {showInnere && showInnere.value && <GermanyInnere data={data} />}
      {showAussere && showAussere.value && <GermanyAussere data={data} />}
      {showPileHead && showPileHead.value && <GermanyPfahlkopf data={data} />}
    </>
  );
}
